<template>
  <section class="ticket">
    <section class="ticket__main-content">
      <p class="ticket__header">Informações de atendimento</p>
      <div class="ticket__item">
        <div class="ticket__item--icon">
          <PatientSvg />
        </div>
        <div class="ticket__item--info">
          <span class="ticket__item--label"> Paciente </span>
          <span class="ticket__item--value"> {{ patientName }} </span>
        </div>
      </div>
      <div class="ticket__item" v-if="unit">
        <div class="ticket__item--icon">
          <PinStrokeSvg />
        </div>
        <div class="ticket__item--info">
          <span class="ticket__item--label"> Laboratório e unidade </span>
          <span class="ticket__item--value"> {{brand}} {{ unit }} </span>
        </div>
      </div>
      <div class="ticket__item">
        <div class="ticket__item--icon">
          <CalendarPlusSvg />
        </div>
        <div class="ticket__item--info">
          <span class="ticket__item--label"> Data </span>
          <span class="ticket__item--value"> {{ scheduleDate }} </span>
        </div>
      </div>
      <div class="ticket__qr-code" v-if="qrcode">
        <span class="ticket__item--label"> Apresente no dia do atendimento</span>
        <div class="ticket__qr-code--icon">
          <InstrucaoAtendentePrdSvg />
        </div>
      </div>
    </section>
    <section class="ticket__survey" v-if="false">
      <span class="ticket__survey--text">
        Seu atendimento requer o preenchimento do questionário de saúde.
      </span>
      <div class="ticket__survey--button">
        Responder questionário
      </div>
    </section>
  </section>
</template>

<script>
export default {
  name: 'InfoTicket',
  props: {
    hasSurvey: Boolean,
    scheduleDate: {
      type: String,
      default: '',
    },
    patientName: {
      type: String,
      default: '',
    },
    unit: String,
    brand: {
      type: String,
      default: '',
    },
    qrcode: Boolean
  },
};
</script>

<style lang="scss" scoped>
.ticket {
  background: var(--color-neutral-0);
  padding: 24px 24px 8px;
  gap: 24px;
  border: 1px solid var(--color-neutral-20);
  border-radius: 8px;
  margin-top: 24px;

  &__header {
    font-weight: var(--font-weight-medium);
    font-size: var(--font-size-3);
    line-height: 24px;
    color: var(--color-fill-grey-10);
    text-align: left;
    padding-bottom: 16px;
  }
  &__item {
    display: flex;
    align-items: center;
    padding-bottom: 16px;

    &--icon {
      padding-right: 12px;
    }
    &--info {
      display: flex;
      flex-direction: column;
      text-align: left;
    }
    &--label {
      font-weight: var(--font-weight-extra-bold);
      font-size: 10px;
      text-transform: uppercase;
      letter-spacing: 1.5px;
      color: #666666;
    }
    &--value {
      font-weight: var(--font-weight-regular);
      font-size: var(--font-size-2);
      color: #161616;

    }
  }
  &__qr-code {
    padding-top: 8px;
    &--icon {
      padding-top: 16px;
      padding-bottom: 24px;
    }
  }

  &__survey {
    border-top: 1px solid rgba(22, 22, 22, 0.12);
    padding-top: 24px;

    &--text {
      font-weight: var(--font-weight-regular);
      font-size: var(--font-size-2);
      color: #161616;
      line-height: 21px;
    }
    &--button {
      margin-top: 24px;
      padding: 24px;
      background: #02103F;
      border-radius: 8px;
      color: var(--color-neutral-20);
      font-size: var(--font-size-3);
      font-weight: var(--font-weight-bold);
      cursor: pointer;
    }
  }
}
</style>
